/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RedrawChallengePrizeBody
 */
export interface RedrawChallengePrizeBody {
    /**
     * 
     * @type {string}
     * @memberof RedrawChallengePrizeBody
     */
    winnerUserId: string;
    /**
     * 
     * @type {string}
     * @memberof RedrawChallengePrizeBody
     */
    notes: string;
}

/**
 * Check if a given object implements the RedrawChallengePrizeBody interface.
 */
export function instanceOfRedrawChallengePrizeBody(value: object): value is RedrawChallengePrizeBody {
    if (!('winnerUserId' in value) || value['winnerUserId'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    return true;
}

export function RedrawChallengePrizeBodyFromJSON(json: any): RedrawChallengePrizeBody {
    return RedrawChallengePrizeBodyFromJSONTyped(json, false);
}

export function RedrawChallengePrizeBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedrawChallengePrizeBody {
    if (json == null) {
        return json;
    }
    return {
        
        'winnerUserId': json['winnerUserId'],
        'notes': json['notes'],
    };
}

export function RedrawChallengePrizeBodyToJSON(json: any): RedrawChallengePrizeBody {
    return RedrawChallengePrizeBodyToJSONTyped(json, false);
}

export function RedrawChallengePrizeBodyToJSONTyped(value?: RedrawChallengePrizeBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'winnerUserId': value['winnerUserId'],
        'notes': value['notes'],
    };
}

